import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

export const TAGS = {
    SURCHARGE_TIME_DEFINITION: 'SURCHARGE_TIME_DEFINITION',
    SURCHARGE_GROUP :"SURCHARGE_GROUP",
}

export const apiRoot = createApi({
    tagTypes: Object.keys(TAGS),
    baseQuery: fetchBaseQuery({
        baseUrl: '/',
        credentials: "include",
        mode: "cors",
        prepareHeaders: headers => {
            headers.set("Content-Type", "application/json")
            return headers
        }
    }),
    endpoints: () => ({}),
})